// src/pages/About.jsx
import React from "react";
import "../styles/Auth.css";
import logo from "../assets/logo.png";
import { motion } from "framer-motion";
import AuthNav from "../components/AuthNav";

export default function About() {
  return (
    <div className="auth-background">
      {/* 顶部导航：Members / About */}
      <AuthNav />

      {/* 整体卡片动画，和登录页一致 */}
      <motion.div
        className="auth-page-container"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.35 }}
      >
        {/* 顶部 Logo */}
        <div className="logo-container">
          <img src={logo} alt="Riceroma Logo" className="auth-logo" />
        </div>

        {/* 内容卡片：中英文品牌故事 */}
        <div
          className="card"
          style={{
            maxWidth: "760px",
            margin: "0 auto 8px",
            padding: "32px 28px",
          }}
        >

          {/* 英文部分 */}
          <section
            style={{
              marginBottom: "20px",
              borderBottom: "1px solid #f0f0f0",
              paddingBottom: "16px",
            }}
          >
            <h3
              style={{
                fontSize: "18px",
                fontWeight: 600,
                marginBottom: "10px",
                color: "#333",
              }}
            >
              Brand Story
            </h3>
            <p
              style={{
                fontSize: "15px",
                lineHeight: "1.8",
                color: "#444",
                marginBottom: "10px",
              }}
            >
              Riceroma was founded in Toronto in 2025 as a quick-service brand focused on Asian rice bowls. 
              We simplify the rich variety of Asian flavors and present them in a modern, health-forward way.
            </p>
            <p
              style={{
                fontSize: "15px",
                lineHeight: "1.8",
                color: "#444",
                marginBottom: "10px",
              }}
            >
              At Riceroma, we work to strengthen the connection between our restaurants and the neighborhoods we serve, 
              bringing local guests closer together and valuing our members’ benefits. 
              Our goal is to open a Riceroma in every Toronto community, serving the people who live there.
            </p>
            <p
              style={{
                fontSize: "15px",
                lineHeight: "1.8",
                color: "#444",
              }}
            >
              We are committed to using real, quality ingredients so guests can enjoy a healthy, 
              satisfying meal even on their busiest days. 
              Our hope is to make “enjoying a good bowl of rice” easy, fast, and worry-free.
            </p>
          </section>

          {/* 中文部分 */}
          <section>
            <h3
              style={{
                fontSize: "18px",
                fontWeight: 600,
                marginBottom: "10px",
                color: "#333",
              }}
            >
              品牌故事
            </h3>
            <p
              style={{
                fontSize: "15px",
                lineHeight: "1.8",
                color: "#444",
                marginBottom: "10px",
              }}
            >
              饭美丽 Riceroma 在2025年创建于多伦多，是一家主营亚洲米饭类产品的快餐品牌。我们将复杂多样的亚洲风味精简，
              用健康现代的方式重新呈现。
            </p>
            <p
              style={{
                fontSize: "15px",
                lineHeight: "1.8",
                color: "#444",
                marginBottom: "10px",
              }}
            >
              在饭美丽，我们努力强化餐厅与社区的联系，紧密团结邻里客人，重视会员权益。我们的目标是在多伦多的每一个社区中，
              都建立一家可以服务居民的餐厅。
            </p>
            <p
              style={{
                fontSize: "15px",
                lineHeight: "1.8",
                color: "#444",
              }}
            >
              我们坚持使用真材实料，让客人在忙碌的一天里，可以快速享用一份健康美味的正餐。
              我们希望让「吃一碗好饭」变得轻松、快捷又安心。
            </p>
          </section>
        </div>
        
        {/* 页脚版权与隐私链接 */}
          <div
            style={{
              textAlign: "center",
              fontSize: "13px",
              color: "#777",
              marginTop: "24px",
              marginBottom: "16px",
            }}
          >
            © 2025 Riceroma ·{" "}
            <a
              href="/privacy"
              style={{ color: "#d77b00", textDecoration: "none" }}
            >
              Privacy Policy
            </a>{" "}
            ·{" "}
            <a
              href="/terms"
              style={{ color: "#d77b00", textDecoration: "none" }}
            >
              Terms of Service
            </a>
          </div>
      </motion.div>
    </div>
  );
}